module.exports = __webpack_public_path__ + "static/img/manual-37.bdd43b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-37.png
// module id = RWy9
// module chunks = 4